/* Product page (sections/product-template-gift.liquid).
   v1.25.10:
   - Size/length pick: when the form carries data-needs-pick="true" no value of that option starts
     selected, the button reads "Select Size" / "Select Length", and Add to Cart asks for the pick
     instead of adding the first variant.
   - Variant resolution: picking a value that has no available variant with the other current choices
     switches to the first available variant that has it, so shoppers never get stuck and the hidden
     variant id always matches what is shown. Values are disabled only when no variant with them is
     available at all.
   - Money is formatted in the cart currency (ProductJson.currency).
   - Add-to-cart errors show inline under the button instead of a browser alert.
   - Removed: the click-anywhere description toggle (the Read more button handles it) and the
     unused installment hook.
   - Visual audit pass: desktop thumbnails are capped to one row with a "+N" tile (capThumbs). */
document.addEventListener("DOMContentLoaded", function () {

  /* ------------------------------
     PRODUCT JSON
  --------------------------------*/
  const jsonEl = document.getElementById("ProductJson");
  if (!jsonEl) return;

  const productData = JSON.parse(jsonEl.textContent);

  const form           = document.querySelector(".product-gift .product-form");
  const variantIdInput = document.getElementById("variantId");
  const totalElement   = document.getElementById("dynamicTotal");
  const priceEl        = document.getElementById("productPrice");
  const atcButton      = document.querySelector(".product-gift .product-add-to-cart");
  const mainImage      = document.querySelector(".product-main-image img");
  const formMsg        = document.getElementById("pgFormMsg");

  const pickIndex = typeof productData.pick_index === "number" ? productData.pick_index : -1;
  let needsPick = !!(form && form.dataset.needsPick === "true" && pickIndex >= 0);

  let currentVariant =
    productData.variants.find(function (v) {
      return variantIdInput && String(v.id) === String(variantIdInput.value);
    }) || productData.variants[0];

  let basePrice = currentVariant.price / 100;

  /* labels come from data attributes so they stay right whatever the button shows at load */
  const addLabel    = (atcButton && atcButton.dataset.atcLabel) || "Add to Cart";
  const selectLabel = (atcButton && atcButton.dataset.selectLabel) || "Select Size";
  const pickMsg     = (form && form.dataset.pickMsg) || "Choose a size to continue.";

  let moneyFmt = null;
  try {
    moneyFmt = new Intl.NumberFormat("en-US", { style: "currency", currency: productData.currency || "USD" });
  } catch (e) {}
  function formatMoney(value) {
    if (moneyFmt) return moneyFmt.format(value);
    return "$" + value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function showMsg(text) {
    if (!formMsg) return;
    formMsg.textContent = text || "";
    formMsg.hidden = !text;
  }

  /* ------------------------------
     PRICE / COMPARE-AT / LIVE REGION (built at runtime)
  --------------------------------*/
  let curEl, cmpEl, saveEl, liveEl;
  if (priceEl) {
    const initialText = priceEl.textContent.trim();
    priceEl.innerHTML =
      '<span class="pg-price-current"></span>' +
      '<span class="pg-price-compare" hidden></span>' +
      '<span class="pg-price-save" hidden></span>';
    curEl  = priceEl.querySelector(".pg-price-current");
    cmpEl  = priceEl.querySelector(".pg-price-compare");
    saveEl = priceEl.querySelector(".pg-price-save");
    curEl.textContent = initialText;

    liveEl = document.createElement("span");
    liveEl.className = "visually-hidden";
    liveEl.setAttribute("aria-live", "polite");
    priceEl.insertAdjacentElement("afterend", liveEl);
  }

  function renderPrice(variant) {
    if (!priceEl) return;
    const price   = variant.price / 100;
    const compare = variant.compare_at_price ? variant.compare_at_price / 100 : 0;
    curEl.textContent = formatMoney(price);
    if (compare > price) {
      cmpEl.textContent = formatMoney(compare);
      cmpEl.hidden = false;
      const pct = Math.round(((compare - price) / compare) * 100);
      saveEl.textContent = "Save " + formatMoney(compare - price) + " (" + pct + "%)";
      saveEl.hidden = false;
      priceEl.classList.add("on-sale");
    } else {
      cmpEl.hidden = true;
      saveEl.hidden = true;
      priceEl.classList.remove("on-sale");
    }
  }

  function renderAtc(variant) {
    if (!atcButton) return;
    if (!variant) {
      atcButton.disabled = true;
      atcButton.textContent = "Unavailable";
      return;
    }
    if (variant.available) {
      atcButton.disabled = false;
      atcButton.textContent = needsPick ? selectLabel : addLabel;
    } else {
      atcButton.disabled = true;
      atcButton.textContent = "Sold Out";
    }
  }

  function announce(variant) {
    if (!liveEl) return;
    liveEl.textContent = (variant.available ? "" : "Sold out. ") + formatMoney(variant.price / 100);
  }

  function pushHistory(variant) {
    if (!history.replaceState) return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      history.replaceState({ variant: variant.id }, "", url.toString());
    } catch (e) {}
  }

  /* ------------------------------
     THUMBNAIL GALLERY
  --------------------------------*/
  const thumbs = document.querySelectorAll(".thumb-image:not(.thumb-video)");
  function clearThumbs() {
    document.querySelectorAll(".thumb-image").forEach(function (t) {
      t.classList.remove("active");
      t.setAttribute("aria-pressed", "false");
    });
  }
  thumbs.forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      if (!mainImage) return;
      const full = thumb.dataset.full;
      if (full) {
        mainImage.src = full;
        mainImage.srcset = thumb.dataset.srcset || "";
        if (thumb.dataset.alt) mainImage.alt = thumb.dataset.alt;
      }
      clearThumbs();
      thumb.classList.add("active");
      thumb.setAttribute("aria-pressed", "true");
    });
  });

  /* Visual audit pass: on desktop, one row of thumbnails with a "+N" tile for the rest.
     Video thumbnails are already in the rail here (oath-video-gallery.js runs first). Phones and
     tablets get a swipe row from CSS instead, so nothing is hidden there. */
  (function capThumbs() {
    const rail = document.querySelector(".product-gift .product-thumbnails");
    if (!rail) return;
    const all = [].slice.call(rail.querySelectorAll(".thumb-image"));
    if (all.length < 3) return;
    const stacked = window.matchMedia("(max-width: 900px)");
    const more = document.createElement("button");
    more.type = "button";
    more.className = "thumb-more";
    more.hidden = true;
    more.setAttribute("aria-expanded", "false");
    rail.appendChild(more);
    let expanded = false;
    let shown = all.length;
    function layout() {
      all.forEach(function (t) { t.classList.remove("is-over"); });
      rail.classList.remove("is-capped");
      more.hidden = true;
      shown = all.length;
      if (expanded || stacked.matches) return;
      const fit = Math.max(2, Math.floor((rail.clientWidth + 8) / 72)); /* 64px tile + 8px gap */
      if (all.length <= fit) return;
      shown = fit - 1;
      all.forEach(function (t, i) { if (i >= shown) t.classList.add("is-over"); });
      rail.classList.add("is-capped");
      more.innerHTML = "+" + (all.length - shown) + '<span class="visually-hidden"> more images</span>';
      more.hidden = false;
    }
    more.addEventListener("click", function () {
      const first = all[shown];
      expanded = true;
      more.setAttribute("aria-expanded", "true");
      layout();
      if (first) first.focus();
    });
    layout();
    let rt;
    window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(layout, 150); });
  })();

  /* ------------------------------
     VARIANT SWITCHING
  --------------------------------*/
  const variantWrap    = document.querySelector(".product-gift .product-variants");
  const variantButtons = document.querySelectorAll(".product-gift .variant-btn");
  const groups = variantWrap ? [].slice.call(variantWrap.querySelectorAll(".variant-buttons")) : [];
  let selectedOptions = currentVariant.options.slice();
  if (needsPick) selectedOptions[pickIndex] = null;

  function exactMatch() {
    return productData.variants.find(function (v) {
      return v.options.every(function (opt, index) { return selectedOptions[index] === opt; });
    });
  }

  function syncButtons() {
    variantButtons.forEach(function (btn) {
      const idx = groups.indexOf(btn.parentElement);
      const on = idx >= 0 && selectedOptions[idx] === btn.dataset.value;
      btn.classList.toggle("active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  variantButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (this.disabled) return;
      const idx = groups.indexOf(this.parentElement);
      if (idx < 0) return;
      const value = this.dataset.value;
      selectedOptions[idx] = value;

      /* If no available variant matches every current choice, move the other choices to the
         closest available variant that has this value (most other options kept). */
      const exact = exactMatch();
      if (!exact || !exact.available) {
        let best = null, bestScore = -1;
        productData.variants.forEach(function (v) {
          if (!v.available || v.options[idx] !== value) return;
          let score = 0;
          v.options.forEach(function (o, i) { if (i !== idx && selectedOptions[i] === o) score++; });
          if (score > bestScore) { best = v; bestScore = score; }
        });
        if (best) {
          best.options.forEach(function (o, i) {
            /* keep an un-picked size/length un-picked */
            if (i === pickIndex && needsPick && i !== idx) return;
            selectedOptions[i] = o;
          });
        }
      }

      if (idx === pickIndex && needsPick) {
        needsPick = false;
        if (form) form.dataset.needsPick = "false";
        showMsg("");
      }

      syncButtons();
      updateVariant();
    });
  });

  function updateVariant() {
    if (selectedOptions.some(function (o) { return o === null || o === undefined; })) {
      renderAtc(currentVariant);
      return;
    }
    const variant = exactMatch();
    if (!variant) {
      renderAtc(null);
      if (liveEl) liveEl.textContent = "This combination is not available.";
      return;
    }

    currentVariant = variant;
    basePrice = variant.price / 100;
    if (variantIdInput) variantIdInput.value = variant.id;

    renderPrice(variant);
    renderAtc(variant);
    announce(variant);
    pushHistory(variant);
    updateTotal();

    if (variant.featured_image && mainImage) {
      mainImage.src = variant.featured_image.src;
      mainImage.srcset = "";
      clearThumbs();
    }
  }

  /* A value is disabled only when no available variant has it. */
  function updateAvailability() {
    variantButtons.forEach(function (btn) {
      const idx = groups.indexOf(btn.parentElement);
      const value = btn.dataset.value;
      const isAvailable = productData.variants.some(function (v) {
        return v.available && v.options[idx] === value;
      });
      btn.classList.toggle("sold-out", !isAvailable);
      btn.disabled = !isAvailable;
    });
  }

  /* ------------------------------
     BUNDLE VARIANT SWITCH
  --------------------------------*/
  document.querySelectorAll(".bundle-item").forEach(function (bundle) {
    const variants = JSON.parse(bundle.dataset.variants);
    const selects  = bundle.querySelectorAll("select");
    const hidden   = bundle.querySelector(".bundle-variant-id");

    function updateBundleVariant() {
      let selected = [];
      selects.forEach(function (select, index) {
        selected[index] = select.value;
      });
      const variant = variants.find(function (v) {
        return v.options.every(function (opt, index) {
          return selected[index] === opt;
        });
      });
      if (!variant || !variant.available) {
        if (hidden) hidden.value = "";
        return;
      }
      if (hidden) hidden.value = variant.id;
      const checkbox = bundle.querySelector(".bundle-checkbox");
      if (checkbox) checkbox.dataset.price = variant.price;
      const priceElB = bundle.querySelector(".bundle-price");
      if (priceElB) priceElB.innerText = formatMoney(variant.price / 100);
    }

    selects.forEach(function (select) {
      select.addEventListener("change", updateBundleVariant);
    });
    updateBundleVariant();
  });

  /* ------------------------------
     BUNDLE + GIFT COLLECTION
  --------------------------------*/
  const bundleCheckboxes = document.querySelectorAll(".bundle-checkbox");

  function getBundleItems() {
    let items = [];
    document.querySelectorAll(".bundle-item").forEach(function (bundle) {
      const checkbox = bundle.querySelector(".bundle-checkbox");
      if (checkbox && checkbox.checked) {
        const hiddenVariant = bundle.querySelector(".bundle-variant-id");
        if (!hiddenVariant || !hiddenVariant.value) return;
        items.push({ id: parseInt(hiddenVariant.value, 10), quantity: 1 });
      }
    });
    return items;
  }

  const giftCheckbox = document.getElementById("giftWrap");
  function getGiftItem() {
    if (giftCheckbox && giftCheckbox.checked) {
      return [{ id: giftCheckbox.dataset.variant, quantity: 1 }];
    }
    return [];
  }

  /* ------------------------------
     DYNAMIC TOTAL
  --------------------------------*/
  function updateTotal() {
    let total = basePrice;
    bundleCheckboxes.forEach(function (box) {
      if (box.checked) total += parseFloat(box.dataset.price) / 100;
    });
    if (giftCheckbox && giftCheckbox.checked) {
      total += parseFloat(giftCheckbox.dataset.price) / 100;
    }
    if (totalElement) totalElement.innerText = formatMoney(total);
  }

  bundleCheckboxes.forEach(function (box) {
    box.addEventListener("change", updateTotal);
  });
  if (giftCheckbox) giftCheckbox.addEventListener("change", updateTotal);

  /* ------------------------------
     ADD TO CART (AJAX, bulk + inline errors)
  --------------------------------*/
  function openDrawerSafe() {
    if (typeof window.openCartDrawer === "function") {
      window.openCartDrawer();
    } else {
      window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "cart";
    }
  }

  function addItemsToCart(items) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          throw new Error((err && err.description) || "This item could not be added to your cart.");
        });
      }
      return res.json();
    });
  }

  function askForPick() {
    showMsg(pickMsg);
    const group = groups[pickIndex];
    if (group) {
      group.scrollIntoView({ behavior: "smooth", block: "center" });
      const first = group.querySelector(".variant-btn:not([disabled])");
      if (first) first.focus({ preventScroll: true });
    }
  }

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (needsPick) { askForPick(); return; }
      if (atcButton && atcButton.disabled) return;
      showMsg("");

      let items = [{ id: variantIdInput.value, quantity: 1 }];
      items = items.concat(getBundleItems());
      items = items.concat(getGiftItem());

      if (atcButton) {
        atcButton.disabled = true;
        atcButton.textContent = "Adding...";
      }

      addItemsToCart(items)
        .then(function () {
          openDrawerSafe();
        })
        .catch(function (err) {
          showMsg(err.message || "Sorry, this item could not be added to your cart.");
        })
        .then(function () {
          renderAtc(currentVariant);
        });
    });
  }

  /* STICKY MOBILE ADD TO CART: lives in snippets/oath-sticky-atc.liquid (the runtime bar that used to be
     built here was removed in July 2026; syncSticky() went with it). */

  /* ------------------------------
     INITIAL SYNC
  --------------------------------*/
  syncButtons();
  if (!needsPick) renderPrice(currentVariant);
  renderAtc(currentVariant);
  updateAvailability();
  updateTotal();

});
